import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Services from "./pages/Services";
import AvLabor from "./pages/AvLabor";
import OrlandoLabor from "./pages/OrlandoLabor";
import Dallas from "./pages/Dallas";
import SanAntonioLabor from "./pages/SanAntonioLabor";
import Employment from "./pages/employment/Employment";
import Pricing from "./pages/Pricing";
import ContactUs from "./pages/ContactUs";
import Footer from "./components/Footer";
import AboutUs from './pages/AboutUs'


function App() {
  return (
    <>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" index element={<Home />} />
          <Route path="services" element={<Services />} />
          <Route path="avlabor" element={<AvLabor />} />
          <Route path="dallasavlabor" element={<Dallas />} />
          <Route path="orlandoavlabor" element={<OrlandoLabor />} />
          <Route path="sanantonioavlabor" element={<SanAntonioLabor />} />
          <Route path="employment" element={<Employment />} />
          <Route path="pricing" element={<Pricing />} />
          <Route path="contactus" element={<ContactUs />} />
          <Route path="aboutus" element={<AboutUs />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
